export default __webpack_public_path__ + "static/media/modarres-removebg-preview.bd7ecc3b.png";